<template>
  <div class="block-item-container">
    <div class="block-item-title-content flex justify-between items-center">
      <div class="title">导师辅导剩余{{ process.task.countdown }}</div>
      <CompleteBtn
        v-if="platform === 'user' && process.task.state !== 'end'"
        :text="''"
        class="over-btn"
        @clickBtn="complete"
      >
        <template v-slot:content>
          <i v-if="loading" class="iconfont iconzhengzaibaocun"></i>
          <span>结束订单</span>
        </template>
      </CompleteBtn>
    </div>
    <div class="process-content flex justify-between">
      <div
        v-for="(item, index) in processList"
        :key="index"
        class="process-item flex flex-col items-center"
        :class="{
          active: processStateMap[process.task.state] >= index,
          current: processStateMap[process.task.state] === index,
        }"
      >
        <div class="circle flex items-center"></div>
        <div class="text-info">
          <div class="process-item-title">{{ item.title }}</div>
          <div v-if="item.date" class="process-item-date">
            {{ item.date | filterDate }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="bottom-tips flex justify-center items-center"
      v-html="processText"
    ></div>
    <CompleteBtn
      v-if="process.task.state !== 'end'"
      :text="platform === 'mentor' ? '提交给用户' : '提交给导师'"
      class="submit-btn"
      @clickBtn="submit"
    />
  </div>
</template>
<script>
import api from "@/api";
import CompleteBtn from "../CompleteButton/CompleteButton.vue";
import { dealSignatrue } from "@/assets/js/util";
import moment from "moment";
export default {
  name: "Process",
  components: {
    CompleteBtn,
  },
  props: {
    process: {
      type: Object,
      default: () => ({}),
    },
    platform: {
      type: String,
      default: "user",
    },
  },
  filters: {
    filterDate(date) {
      return moment(date).format("YYYY/MM/DD");
    },
  },
  data() {
    return {
      moment,
      loading: false,
      processStateMap: {
        unanswered: 1,
        replied: 2,
        end: 3,
        user_overdue: 3,
      },
    };
  },
  computed: {
    processList() {
      const { task } = this.process;
      if (!task) return [];
      return [
        {
          title: "分配导师",
          date: task.create_at,
        },
        {
          title: "修改中",
          date: task.state === "unanswered" ? task.updated_at : "",
        },
        {
          title: "已修改",
          date: task.state === "replied" ? task.updated_at : "",
        },
        {
          title: "辅导结束",
          date:
            task.state === "end" || task.state === "user_overdue"
              ? task.finished_at
              : "",
        },
      ];
    },
    getEndTimeStatus() {
      let countdown = this.process.task.countdown;
      let isTrue =
        countdown === "0天" ||
        (countdown || "").replace(/(\d{1,}).*/gim, "$1") == 0;
      this.process.task.state = isTrue ? "end" : this.process.task.state;
      return isTrue;
    },
    processText() {
      const { task } = this.process;
      if (
        task.state === "end" ||
        this.getEndTimeStatus ||
        task.state === "user_overdue"
      ) {
        return this.platform === "mentor"
          ? "辅导订单已结束，感谢您的认真辅导！"
          : `辅导订单已结束，您可以对此次辅导的导师做出评价`;
      } else if (task.state === "replied") {
        return this.platform === "mentor"
          ? "已提交反馈给用户，如有其他需补充的内容，可继续回复用户"
          : "导师已给出反馈，如有其它问题，请先提问，然后提交给导师继续修改";
      } else if (task.state === "unanswered") {
        return this.platform === "mentor"
          ? "请根据用户求职目标，结合具体问题给出建议，可在简历中用【】标注和修改"
          : `导师正在对您的简历作出修改建议，预计 <span style="color: #FF4F4C;font-weight: 600;">${
              this.process.urgency === "24hours"
                ? "1"
                : this.process.urgency === "48hours"
                ? "2"
                : "3"
            }个工作日</span> 收到回复，请耐心等待`;
      } else {
        return `数据正在加载中...`;
      }
    },
  },
  methods: {
    async complete() {
      try {
        const confirm = await this.$wondercv.showConfirm({
          title: "温馨提示",
          content: "即将提前结束导师辅导服务，是否现在结束订单？",
        });
        if (confirm) {
          if (this.loading) return;
          this.loading = true;
          const payload = await dealSignatrue({
            complete: true,
            cv_token: this.$store.state.editor.cvDetail.basic_info.token,
          });
          let res = await api.cvsEditor.updateTaskState(payload);
          if (res.code === 1000) {
            this.$message.success("结束订单成功");
            this.$emit("refresh");
          } else {
            this.$message.error(res.message);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async submit() {
      try {
        const confirm = await this.$wondercv.showConfirm({
          title: "温馨提示",
          content: `即将把简历和问题提交给${
            this.platform === "mentor" ? "用户" : "导师"
          }，是否确认已修改完毕？`,
        });
        if (confirm) {
          const token = this.$store.state.editor.cvDetail.basic_info.token;
          const res = await api.cvsEditor.updateTaskState({
            cv_token: token,
          });
          await api.mentorOrders.mentorCvsSync(token);
          if (res.code === 1000) {
            this.$message.success("提交成功");
            this.$emit("refresh");
          } else {
            this.$message.error(res.message);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.over-btn {
  width: 104px;
  height: 32px;
  border-radius: 18px;
  white-space: nowrap;
  .iconfont {
    font-size: 14px;
    margin-right: 6px;
    animation: spin 2s linear infinite;
  }
}
.process-content {
  margin-top: 24px;
  .process-item {
    position: relative;
    flex: 1;
    .circle {
      position: relative;
      z-index: 2;
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background-color: $mentor-process-default-color;
      margin-bottom: 12px;
    }
    &:not(:first-child) {
      &::before {
        position: absolute;
        top: 4px;
        right: 50%;
        content: "";
        display: inline-block;
        width: calc(100% + 35px);
        height: 1px;
        background-color: $mentor-process-default-color;
        z-index: 1;
      }
    }
    .text-info {
      text-align: center;
      .process-item-title {
        color: $text-color;
        margin-bottom: 4px;
      }
      .process-item-date {
        color: #5a616e;
      }
    }
    &:first-child {
      align-items: flex-start;
      .circle {
        margin-left: 24px;
      }
      .text-info {
        text-align: left;
      }
    }
    &:last-child {
      align-items: flex-end;
      &::before {
        right: 24px;
      }
      .circle {
        margin-right: 24px;
      }
      .text-info {
        text-align: right;
      }
    }
    &.active {
      .circle {
        background-color: $theme-color;
      }
      &::before {
        background-color: $theme-color;
        z-index: 2;
      }
    }
    &.current {
      .circle::after {
        content: "";
        display: inline-block;
        background-color: rgba($color: #f64, $alpha: 0.3);
        width: 19px;
        height: 19px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
.bottom-tips {
  margin-top: 14px;
  color: $text-color;
  background-color: $btn-bg-color;
  border-radius: 8px;
  min-height: 44px;
}
.submit-btn {
  margin: 24px auto 0;
  width: 240px;
  height: 40px;
  border-radius: 20px;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
